var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"width":"40%","visible":_vm.dialogVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-image',{staticStyle:{"width":"100%","margin":"20px auto"},attrs:{"fit":"contain","src":_vm.url,"preview-src-list":_vm.fileList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }